<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Raw Material Requisition List
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-card class="pa-4">

                  <v-data-table
                    :headers="headers"
                    :items="getInvProductionReceiveList"
                    :item-value="'id'"
                    class="elevation-1"
                  >
                    <template #item.index="{ index }">
                      {{ ++index }}
                    </template>

                    <template #item.status="{ item }">
                      <v-chip
                        v-if="item.approval_status == 'Approved'"
                        color="success"
                        size="small"
                      >
                        Approved
                      </v-chip>

                      <v-chip v-else color="red" size="small">
                        Pending
                      </v-chip>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-icon
                          small
                          @click="viewDetails(item)"
                          
                          class="me-2 edit-button"
                          title="View Invoice"
                          color="blue"
                      >
                        mdi-file-document-outline
                    </v-icon>
                  
                    <v-icon
                      class="me-2 edit-button"
                      color="primary"
                      @click="editItem(item)"
                      
                    >
                      mdi mdi-pencil-outline
                    </v-icon>
                    </template>
                  </v-data-table>
                </v-card>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>

import { ref,computed,onMounted } from "vue"
import { useStore } from "vuex"

import { useForm,useField } from "vee-validate"
import * as yup from "yup"
import { useRouter } from "vue-router";
const router = useRouter();



const store = useStore()



const panel = ref([0])
const dialog = ref(false)
const isEdit = ref(false)

const templateId = ref(null)



/* -----------------------------
YUP VALIDATION
--------------------------------*/

const schema = yup.object({

  name: yup
    .string()
    .required("Template name is required"),

  product_id: yup
    .number()
    .required("Product is required")
    .typeError("Product is required"),

  status: yup.number(),

//   cart: yup
//     .array()
//     .of(
//       yup.object({
//         raw_product_id: yup
//           .number()
//           .required("Raw product is required")
//           .typeError("Raw product is required"),

//         quantity: yup
//           .number()
//           .required("Quantity required")
//           .min(0.01, "Quantity must be greater than 0"),

//         process_loss_percent: yup
//           .number()
//           .required("Loss percent required")
//           .min(0, "Loss cannot be negative")
//           .max(100, "Loss cannot exceed 100%"),
//       })
//     )
//     .min(1, "At least one raw product required"),
});



const { handleSubmit,setErrors, resetForm  } = useForm({
  validationSchema: schema,
  initialValues: {
    name: "",
    product_id: null,
    status: 1,
    cart: []
  }
});



const { value:name,errorMessage:nameError } = useField("name")
const { value:product_id,errorMessage:productError } = useField("product_id")
const { value:status } = useField("status")

/* -----------------------------
CART
--------------------------------*/

const cart = ref([{
    raw_product_id:null,
    quantity:0,
    process_loss_percent:0
}])



/* -----------------------------
TABLE
--------------------------------*/

const headers = [
    { title:"#SL", key:"index"},
    { title:"Code", key:"code"},
    { title:"Receive Date", key:"receive_date"},
    { title:"Warehouse", key:"warehouse.name"},
    { title:"Approval Status", key:"status"},
    { title:"Actions", key:"actions"}
]



const getInvProductionReceiveList = computed(()=>{
    console.log("HGIJGHJGHJGHJGHJ");
    console.log(store.getters.getInvProductionReceiveList);
    return store.getters.getInvProductionReceiveList
})


const productList = computed(()=>{
    return store.getters.getProductList
})



/* -----------------------------
LOAD DATA
--------------------------------*/

const loadTemplates = async ()=>{
    await store.dispatch("getInvProductionReceiveList")
}

const loadProduct = async ()=>{
    await store.dispatch("getProductList")
}



/* -----------------------------
CREATE
--------------------------------*/

const openCreate = ()=>{

isEdit.value=false

resetForm({
    values:{
        name:"",
        product_id:null,
        status:1
    }
})

cart.value=[{
raw_product_id:null,
quantity:0,
process_loss_percent:0
}]

dialog.value=true

}



/* -----------------------------
EDIT
--------------------------------*/

const editTemplate = async(item)=>{

isEdit.value=true
templateId.value=item.id

const response = await store.dispatch("getTemplateById",item.id)

const data = response.data

name.value = data.name
product_id.value = data.product_id
status.value = data.status

cart.value = []

data.items.forEach((item)=>{
cart.value.push({
raw_product_id:item.raw_product_id,
quantity:item.quantity,
process_loss_percent:item.process_loss_percent
})
})

dialog.value=true

}



/* -----------------------------
CART ROW
--------------------------------*/

const addRow = ()=>{

cart.value.push({
raw_product_id:null,
quantity:0,
process_loss_percent:0
})

}

const removeRow = (index)=>{
cart.value.splice(index,1)
}



/* -----------------------------
BUILD PAYLOAD
--------------------------------*/

const buildPayload = ()=>{

let payload={
name:name.value,
product_id:product_id.value,
status:status.value,
cart:[]
}

cart.value.forEach((item)=>{

payload.cart.push({
raw_product_id:item.raw_product_id,
quantity:item.quantity,
process_loss_percent:item.process_loss_percent
})

})

return payload

}



/* -----------------------------
SAVE
--------------------------------*/
const saveTemplate = handleSubmit(async (values)=>{

  values.cart = cart.value

  try{

    const payload = buildPayload()

    if(isEdit.value){

      payload.id = templateId.value
      await store.dispatch("updateTemplate",payload)

    }else{

      await store.dispatch("saveTemplate",payload)

    }

    dialog.value=false
    loadTemplates()

  }catch(error){

    if(error.response && error.response.status === 422){

      const backendErrors = error.response.data.errors
      setErrors(backendErrors)

    }

  }

})

function editItem(item){
  router.push({ name: "production-receive", query: { id: item.id },});
}

function viewDetails(item){
  router.push({ name: "production-receive-details", params: { id: item.id } });
}



/* -----------------------------
MOUNT
--------------------------------*/

onMounted(()=>{
    loadProduct()
    loadTemplates()
})
</script>
